import React from 'react';
import { Link } from 'react-router-dom';
import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/src/shadComponents/ui/button';
import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface AccountActionsProps {
    row: any;
    onDelete: () => void;
}

export default function AccountActions({ row, onDelete }: AccountActionsProps) {
    const accountId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `accounts/${accountId}`
            );

            if (response.status === 200) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete ${row.original.username}`
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };
    return (
        <div className="flex items-center gap-2">
            <Link to={`${accountId}`}>
                <Button variant="ghost" size="icon-xs">
                    <Pencil className="size-4" />
                </Button>
            </Link>
            <Button variant="ghost" size="icon-xs" onClick={performDelete}>
                <Trash2 className="size-4" />
            </Button>
        </div>
    );
}
